// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1WRJG","loaderOuter":"PageOverlayLoader_loaderOuter__3WqiG"};